import React, { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Typography,
} from '@mui/material';
import { LoadScript, GoogleMap, Marker } from '@react-google-maps/api';
import CustomButton from './elements/CustomButton/CustomButton';

const MapPickerPopup = ({ isOpen, handleClose, address, zipCode, onSelect , height = "400px"}) => {
  const mapRef = useRef(null);
  const [mapCenter, setMapCenter] = useState({ lat: 20.5937, lng: 78.9629 }); // Default India center
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [displayedLocation, setDisplayedLocation] = useState("");
  const [mapKey, setMapKey] = useState(0); // 🔁 Force remount of LoadScript


  useEffect(() => {
      if (isOpen) {
    handleGeocode();
  }
}, [isOpen]);


  const resetState = () => {
    setMapCenter({ lat: 20.5937, lng: 78.9629 });
    setSelectedPoint(null);
    setLoading(true);
    setScriptLoaded(false);
    setDisplayedLocation("");
    setMapKey((prev) => prev + 1); // 🔁 Force LoadScript re-render
  };

  const handleGeocode = () => {
  const fullAddress = address?.trim() ? `${address}, ${zipCode}` : zipCode;

  setDisplayedLocation(fullAddress || "Unknown location");

  if (!window.google || !window.google.maps) {
    setLoading(false);
    return;
  }

  if (!fullAddress) {
    setLoading(false);
    return;
  }

  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode({ address: fullAddress }, (results, status) => {
    if (status === 'OK' && results[0]) {
      const location = results[0].geometry.location;
      setMapCenter({ lat: location.lat(), lng: location.lng() });
    } else {
      console.warn('Geocode failed:', status);
    }
    setLoading(false);
  });
};


  useEffect(() => {
    if (isOpen) {
      resetState();
    }
  }, [isOpen]);

  useEffect(() => {
    if (scriptLoaded && isOpen) {
      handleGeocode();
    }
  }, [scriptLoaded, isOpen]);

  const handleMapClick = (e) => {
    const latLng = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setSelectedPoint(latLng);
  };

  const handleSave = () => {
    if (selectedPoint) {
      onSelect(selectedPoint);
    }
    handleClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose();
        }
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Select Location on Map</DialogTitle>
      <DialogContent>
        <div className="mb-3">
          <Typography variant="body2" className="text-gray-600">
            Searching for: <strong>{displayedLocation || "None"}</strong>
          </Typography>
        </div>

        {/* <LoadScript
          key={mapKey} 
          googleMapsApiKey={apiKey}
          onLoad={() => setScriptLoaded(true)}
        > */}
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <CircularProgress />
            </div>
          ) : (
            <GoogleMap
              mapContainerStyle={{ width: '100%', height }}
              center={mapCenter}
              zoom={14}
              onLoad={(map) => (mapRef.current = map)}
              onClick={handleMapClick}
            >
              {selectedPoint && <Marker position={selectedPoint} />}
            </GoogleMap>
          )}
        {/* </LoadScript> */}
      </DialogContent>

      <DialogActions className="px-6 pb-4">
        <CustomButton
          onClick={handleClose}
          customeClass="primary-custom-button w-full sm:w-[150px] h-[40px]"
        >
          Cancel
        </CustomButton>
        <CustomButton
          onClick={handleSave}
          customeClass="gradient-button w-full sm:w-[150px] h-[40px]"
          disabled={!selectedPoint}
        >
          Save Location
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default MapPickerPopup;

